import { render, staticRenderFns } from "./OrdersBySalespersonChart.vue?vue&type=template&id=09a38ef0&scoped=true&"
import script from "./OrdersBySalespersonChart.vue?vue&type=script&lang=js&"
export * from "./OrdersBySalespersonChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a38ef0",
  null
  
)

export default component.exports